//Requiring the int module when not available in a browser like safari
if(!global.Intl) {
    // No `Intl`, so use and load the polyfill.
    polyfillAddLocaleData();
}

// This function corrects an ie11 bug where .includes is not present.
if (!String.prototype.includes) {
  String.prototype.includes = function(search, start) {
    if (typeof start !== 'number') {
      start = 0;
    }
     if (start + search.length > this.length) {
      return false;
    } else {
      return this.indexOf(search, start) !== -1;
    }
  };
}

var HudlBase = require('hudl-base');
var logger = new HudlBase.Logger('hudl-g11n');
var data = HudlBase.data;
var IntlMessageFormat = require('intl-messageformat');

var ReactIntl = reactIntlAddLocale();

var _cache = {};
var _locale = data.getNullable('i18nLocale') || 'en-US';
var _messages = data.getNullable('i18nMessages') || {};

module.exports = {
  format: function(key, args, defaultMessage) {
    var result = '';
    try {
      if (!_messages.hasOwnProperty(key)) {
        result = defaultMessage || key;
        if(key === result) {
          logger.log("i18n ClientSideError: Missing Key on Client Side. Did you remember to send the key in your controller.",
            {Key:key,
             Translation:result,
             Locale:_locale,
             Args:JSON.stringify(args)
            });
        }
        return result;
      }
      if (!args) {
        result = _messages[key];
        if (result.includes('{') && _locale !== 'hudl-pseudo') {
            //The translation might contain ICU formatting and the dev forgot to include the argument
            logger.log("i18n ClientSideWarning: User Display text contains ICU formatting when no args were passed",
              {Key:key,
               Locale:_locale,
               Translation:result});
        }
        return result;
      }
      if (!_cache.hasOwnProperty(key)) {
        _cache[key] = new IntlMessageFormat(_messages[key], _locale);
      }
      result = _cache[key].format(args);
      if(key === result && _locale !== 'hudl-key') {
         //with hudl-key the result will be equal to the key, so we don't log that as this is expected.
         logger.log("i18n ClientSideError: Translation matching Key",
          {Key:key,
           Translation:result,
           Locale:_locale,
           Args:JSON.stringify(args)});
      }

      result = result || defaultMessage || key;
      return result;
    }
    catch(ex)
    {
      var message = "";
      if (ex.message) {
        message += ex.message;
      }
      if (ex.stack) {
        message += ' | stack: ' + ex.stack;
      }
      result = defaultMessage || key;
      logger.log("i18n ClientSideError: Cannot Format Translation.",
        {Key:key,
         Translation:"["+result+"]",
         Locale:_locale,
         Error: "["+message+"]",
         Args:"["+JSON.stringify(args)+"]"});
      return result;
    }
  },
  'ReactIntl': ReactIntl,
  'locale': _locale,
  'messages': _messages,
  'logger': logger
};

function polyfillAddLocaleData() {
  global.Intl = require('intl');
  // Polyfill the required locale data
  // Note: should match locales added by ReactIntl below
  require('intl/locale-data/jsonp/en.js');
  require('intl/locale-data/jsonp/es.js');
  require('intl/locale-data/jsonp/fr.js');
  //https://github.com/andyearnshaw/Intl.js/blob/master/locale-data/jsonp/de.js
  require('intl/locale-data/jsonp/de.js');
  //https://github.com/andyearnshaw/Intl.js/blob/master/locale-data/jsonp/pt.js
  require('intl/locale-data/jsonp/pt.js');
  //https://github.com/andyearnshaw/Intl.js/blob/master/locale-data/jsonp/it.js
  require('intl/locale-data/jsonp/it.js');
  //https://github.com/andyearnshaw/Intl.js/blob/master/locale-data/jsonp/ru.js
  require('intl/locale-data/jsonp/ru.js');
  //https://github.com/andyearnshaw/Intl.js/blob/master/locale-data/jsonp/ja.js
  require('intl/locale-data/jsonp/ja.js');
  //https://github.com/andyearnshaw/Intl.js/blob/master/locale-data/jsonp/ja-JP.js
  require('intl/locale-data/jsonp/ja-JP.js');
  //https://github.com/andyearnshaw/Intl.js/blob/master/locale-data/jsonp/zh.js
  require('intl/locale-data/jsonp/zh.js');
  //https://github.com/andyearnshaw/Intl.js/blob/master/locale-data/jsonp/nl.js
  require('intl/locale-data/jsonp/nl.js');
  //https://github.com/andyearnshaw/Intl.js/blob/master/locale-data/jsonp/tr.js
  require('intl/locale-data/jsonp/tr.js');
  //https://github.com/andyearnshaw/Intl.js/blob/master/locale-data/jsonp/ar.js
  require('intl/locale-data/jsonp/ar.js');
  //https://github.com/andyearnshaw/Intl.js/blob/master/locale-data/jsonp/hr.js
  require('intl/locale-data/jsonp/hr.js');
  //https://github.com/andyearnshaw/Intl.js/blob/master/locale-data/jsonp/cs.js
  require('intl/locale-data/jsonp/cs.js');
  //https://github.com/andyearnshaw/Intl.js/blob/master/locale-data/jsonp/da.js
  require('intl/locale-data/jsonp/da.js');
  //https://github.com/andyearnshaw/Intl.js/blob/master/locale-data/jsonp/fi.js
  require('intl/locale-data/jsonp/fi.js');
  //https://github.com/andyearnshaw/Intl.js/blob/master/locale-data/jsonp/el.js
  require('intl/locale-data/jsonp/el.js');
  //https://github.com/andyearnshaw/Intl.js/blob/master/locale-data/jsonp/hu.js
  require('intl/locale-data/jsonp/hu.js');
  //https://github.com/andyearnshaw/Intl.js/blob/master/locale-data/jsonp/pl.js
  require('intl/locale-data/jsonp/pl.js');
  //https://github.com/andyearnshaw/Intl.js/blob/master/locale-data/jsonp/sv.js
  require('intl/locale-data/jsonp/sv.js');
  //https://github.com/andyearnshaw/Intl.js/blob/master/locale-data/jsonp/nb-NO.js
  require('intl/locale-data/jsonp/nb-NO.js');
  //https://github.com/andyearnshaw/Intl.js/blob/master/locale-data/jsonp/ko.js
  require('intl/locale-data/jsonp/ko.js');
  //https://github.com/andyearnshaw/Intl.js/blob/master/locale-data/jsonp/th.js
  require('intl/locale-data/jsonp/th.js');
  //https://github.com/andyearnshaw/Intl.js/blob/master/locale-data/jsonp/sr.js
  require('intl/locale-data/jsonp/sr.js');
}

function reactIntlAddLocale() {
  var ReactIntl = require('react-intl');
  //TODO we should be dynamically load these locales from the server side, this will require
  // - Hudl.I18n version update
  // - Updating the controller that send the data
  //or see if we can simply add the locale data from the _locale variable.
  ReactIntl.addLocaleData(require('react-intl/locale-data/en'));
  ReactIntl.addLocaleData(require('react-intl/locale-data/es'));
  ReactIntl.addLocaleData(require('react-intl/locale-data/fr'));
  ReactIntl.addLocaleData(require('react-intl/locale-data/de'));
  ReactIntl.addLocaleData(require('react-intl/locale-data/pt'));
  ReactIntl.addLocaleData(require('react-intl/locale-data/it'));
  ReactIntl.addLocaleData(require('react-intl/locale-data/ru'));
  ReactIntl.addLocaleData(require('react-intl/locale-data/ja'));
  ReactIntl.addLocaleData(require('react-intl/locale-data/zh'));
  ReactIntl.addLocaleData(require('react-intl/locale-data/nl'));
  ReactIntl.addLocaleData(require('react-intl/locale-data/tr'));
  ReactIntl.addLocaleData(require('react-intl/locale-data/ar'));
  ReactIntl.addLocaleData(require('react-intl/locale-data/hr'));
  ReactIntl.addLocaleData(require('react-intl/locale-data/cs'));
  ReactIntl.addLocaleData(require('react-intl/locale-data/da'));
  ReactIntl.addLocaleData(require('react-intl/locale-data/fi'));
  ReactIntl.addLocaleData(require('react-intl/locale-data/el'));
  ReactIntl.addLocaleData(require('react-intl/locale-data/hu'));
  ReactIntl.addLocaleData(require('react-intl/locale-data/pl'));
  ReactIntl.addLocaleData(require('react-intl/locale-data/sv'));
  ReactIntl.addLocaleData(require('react-intl/locale-data/nb'));
  ReactIntl.addLocaleData(require('react-intl/locale-data/ko'));
  ReactIntl.addLocaleData(require('react-intl/locale-data/th'));
  ReactIntl.addLocaleData(require('react-intl/locale-data/sr'));

  return ReactIntl;
};
